// @return {Boolean} True if `window` is under mqLg
module.exports = () => {
  const mqLg = window.getComputedStyle(document.documentElement).getPropertyValue('--grd-lg') || '1024px';

	return !window.matchMedia(`screen and (min-width: ${mqLg})`).matches;
};
